import React from "react";
import Logo from '../../../assets/logo.svg';
import moment from "moment";
import Barcode from 'react-barcode';
import './css/ticket.css';
import 'moment/locale/id';
moment.locale('id');

export class ComponentToPrint extends React.PureComponent {
  render() {
    const numberFormat = (value) =>
      new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value);


    var birthdateTimeStamp = new Date(this.props.item.TANGGAL_LAHIR);
    var cur = new Date();
    var diff = cur - birthdateTimeStamp;
    var currentAge = Math.floor(diff / 31557600000);

    return (
      <div className='hide-print'>
        <div
          className="container-fluid"
        >
          <>
            <div style={{
              height: '100%',
              width: '100%',
              overflowX: "auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}>
              <table className="table_ticket">
                <tbody>
                  <tr>
                    <td>
                      <img
                        src={Logo}
                        width="620"
                        alt="Logo"
                        style={{
                          padding: 20,
                          display: "block",
                          margin: 'auto'
                        }}
                      />
                      {/* <p style={{ fontSize: '40px', fontWeight: 'bold' }}>BIOMEDIKA</p> */}
                    </td>
                  </tr>
                  {/* <tr>
                    <td>
                      <p style={{margin:'10px'}}>Jl. Arjuna Utara No.11, Duri Kepa, Kec. Kb. Jeruk, Kota Jakarta Barat,
                      Daerah Khusus Ibukota Jakarta 11510</p>
                    </td>
                  </tr> */}

                  <tr>
                    <td>
                      <p style={{ fontSize: '64px', fontWeight: 'bold', margin: '0px' }}>No antrian anda:</p>
                      <p style={{ fontSize: '34px', fontWeight: 'bold', margin: '0px' }}>a.n. {this.props.item.NAMA_PASIEN}</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: '10px' }}>
                      <div style={{ border: '4px solid #000', width: '800px', margin: 'auto', }}>
                        <p style={{ fontSize: '160px', fontWeight: 'bold', margin: '0px' }}>{this.props.item.ANTRIAN_DOKTER}</p>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                    
                      <p style={{ fontSize: '44px', margin: '0px' }}> NOMOR INI HANYA BERLAKU PADA TANGGAL <span style={{fontWeight: 'bold'}}>{moment(moment.utc(this.props.item.TGL_LAYANAN)).local().format("DD MMMM YYYY")}</span></p>
                      {/* <p style={{ fontSize: '34px', margin: '0px' }}></p> */}
                    </td>
                  </tr>
                  <tr>
                    <td><p style={{ fontSize: '44px', fontWeight: 'bold' }}>TERIMA KASIH</p></td>
                  </tr>
                </tbody>
              </table>
            </div>

          </>
        </div>
      </div>
    );
  }
}